<template>
  <div class="status-label">
    <span class="text">{{ status }}</span>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "#4FB989",
    },
  },
};
</script>

<style scoped lang="scss">
.status-label {
  border-radius: 50px;
  background: var(--Green, v-bind(color));
  padding: 5px 4px;
  gap: 10px;
  width: fit-content;

  .text {
    color: #fff;
    text-align: right;
    font-family: Heebo;
    font-size: 17px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
  }
}
</style>
